// Content checks for coach notes (ENG-7964). Autosave must not create a
// draft for an empty form, and drafts are never shown in a member's history.

type LexicalNode = { text?: unknown; children?: unknown };

// True when a serialized Lexical state contains any non-whitespace text.
// Accepts the editor state object or its JSON string (as stored on a note).
export const hasOverviewText = (overview: unknown): boolean => {
  let state = overview;
  if (typeof state === "string") {
    if (!state.trim()) return false;
    try {
      state = JSON.parse(state);
    } catch {
      // Legacy plain-text overview
      return true;
    }
  }

  const visit = (node: unknown): boolean => {
    if (!node || typeof node !== "object") return false;
    const { text, children } = node as LexicalNode;
    if (typeof text === "string" && text.trim()) return true;
    return Array.isArray(children) && children.some(visit);
  };
  return visit((state as { root?: unknown } | null)?.root);
};

// A note has content once it has a topic, a link or session overview text.
// Date of Session and Coach Session Type always have values, so they don't count.
export const hasNoteContent = (content: {
  topicIds: number[];
  externalLinks: string[];
  sessionOverview: unknown;
}): boolean =>
  content.topicIds.length > 0 ||
  content.externalLinks.length > 0 ||
  hasOverviewText(content.sessionOverview);

// The notes shown in a member's history: submitted notes only.
export const submittedNotes = <T extends { isDraft?: boolean }>(notes: T[]): T[] =>
  notes.filter((note) => !note.isDraft);
